import isUndefined from 'lodash/isUndefined';

function getCurrencySign(currency) {
  if (currency === "EUR") return "\u20ac";
  if (currency === "GBP") return "\u00a3";

  return "$";
}

export function getPriceStr(price, currency) {
  return `${getCurrencySign(currency)}${price}`;
}

export function pluralize(str, count) {
  return count > 1 ? `${str}s` : str;
}

export function getPercent(float) {
  return Number((1 - float)*100).toFixed(10).replace(/(\.0+|0+)$/, "") + "%"
}

export function reducer(handlers, initialState = {}) {
  return (state = initialState, action) => {
    const handler = handlers[action.type];
    let result;

    if (handler) {
      result = handler(state, action);
    }

    if (isUndefined(result)) {
      return state;
    }  else {
      return result;
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils.js